"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Discussion = function Discussion(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M14 5.5H6C5.86739 5.5 5.74021 5.55268 5.64645 5.64645C5.55268 5.74021 5.5 5.86739 5.5 6V14C5.5 14.1326 5.55268 14.2598 5.64645 14.3536C5.74021 14.4473 5.86739 14.5 6 14.5H11.5V16C11.5 16.0989 11.5293 16.1956 11.5843 16.2778C11.6392 16.36 11.7173 16.4241 11.8087 16.4619C11.9 16.4998 12.0006 16.5097 12.0975 16.4904C12.1945 16.4711 12.2836 16.4235 12.3536 16.3536L14.3536 14.3536C14.4 14.3071 14.4368 14.252 14.4619 14.1913C14.4871 14.1307 14.5 14.0657 14.5 14V6C14.5 5.86739 14.4473 5.74021 14.3536 5.64645C14.2598 5.55268 14.1326 5.5 14 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M18 9.5H10C9.86739 9.5 9.74021 9.55268 9.64645 9.64645C9.55268 9.74021 9.5 9.86739 9.5 10V18C9.5 18.1326 9.55268 18.2598 9.64645 18.3536C9.74021 18.4473 9.86739 18.5 10 18.5H15.5V20C15.5 20.0989 15.5293 20.1956 15.5843 20.2778C15.6392 20.36 15.7173 20.4241 15.8087 20.4619C15.9 20.4998 16.0006 20.5097 16.0975 20.4904C16.1945 20.4711 16.2836 20.4235 16.3536 20.3536L18.3536 18.3536C18.4 18.3071 18.4368 18.252 18.4619 18.1913C18.4871 18.1307 18.5 18.0657 18.5 18V10C18.5 9.86739 18.4473 9.74021 18.3536 9.64645C18.2598 9.55268 18.1326 9.5 18 9.5Z",
    fill: props.foregroundColor
  }));
};

Discussion.defaultProps = {
  altText: "Discussion",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Discussion.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Discussion;
exports.default = _default;